// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_VariantSaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_VariantSaveInput — body for
 * POST /subscriptions/admin-terms/variant-save.
 *
 * Writes one language of one version. Creating a variant and editing it are
 * the same call on purpose: the pair (term, language) is unique, so "save the
 * Spanish of version 2" has exactly one meaning.
 *
 * Refusals: 'termo_nao_encontrado', 'language_unsupported'.
 */
import { registerContract } from './validate'

export interface SubscriptionTerms_VariantSaveInput {
term_id: number
language: string
conteudo: string
}

registerContract('SubscriptionTerms_VariantSaveInput', {
  term_id:  { type: 'number',  required: true },
  language: { type: 'string',  required: true },
  conteudo: { type: 'string',  required: true },
})
